<template>
<span>
    <span v-if="hasPrev"><a @click="next(prevPage)">{{t('app.registration.summary.previous')}}</a></span>
    <span v-if="hasFirst"><a @click="next(1)">1</a></span>
    <span v-if="hasFirst">...</span>
    <span v-for="page in pages">
        <a @click="next(page)" :class="{current: current_class(page)}">
            {{ page }}
        </a>
    </span>
    <span v-if="hasLast">...</span>
    <span v-if="hasLast"><a @click="next(totalPages)">{{ totalPages }}</a></span>
    <span v-if="hasNext"><a @click="next(nextPage)">{{t('app.registration.summary.next')}}</a></span>
</span>
</template>

<script>
    export default {
        props: {
            current_page: {
              type: Number,
              default: null
            },
            with_emitter: {
              type: Boolean,
              default: false
            },
            total: {
                type: Number,
                default: 0
            },
            perPage: {
                type: Number,
                default: 25
            },
            pageRange: {
                type: Number,
                default: 2
            }
        },
        computed: {
          current(){
            return parseInt(this.$route.query.page) || this.current_page || 1
          },
          pages: function () {
            let pages = []
            for (let i = this.rangeStart; i <= this.rangeEnd; i++) {
              pages.push(i)
            }
            return pages
          },
          rangeStart: function () {
            let start = this.current - this.pageRange
            return (start > 0) ? start : 1
          },
          rangeEnd: function () {
            let end = this.current + this.pageRange
            return (end < this.totalPages) ? end : this.totalPages
          },
          totalPages: function () {
            return Math.ceil(this.total / this.perPage)
          },
          nextPage: function () {
            return this.current + 1
          },
          prevPage: function () {
            return this.current - 1
          },
          hasPrev: function () {
            return this.current > 1
          },
          hasFirst: function () {
            return this.rangeStart !== 1
          },
          hasLast: function () {
            return this.rangeEnd < this.totalPages
          },
          hasNext: function () {
            return this.current < this.totalPages
          },
        },
      methods: {
        current_class(page){
          return this.current === page
        },
        next(page){
          if (this.with_emitter){
            this.$emit('page_change', page)
          }else{
            if (page === 1){
              let query = this.clone_obj(this.$route.query)
              delete query.page
              this.$router.push({to: this.$route.path, query: query}) // need here per for reports
            }
            this.$router.push({to: this.$route.path, query: {...this.$route.query, page: page}})
          }

        }
      }
    }
</script>
